
<template>
  <div class="page-wrapper" id="main-wrapper" data-layout="horizontal"
    :data-sidebartype="NavigationStateSingleton.dropdown_active.nav_menu ? 'full' : 'mini-sidebar'"
    data-sidebar-position="fixed" data-header-position="fixed" :class="{
      'dark-theme': LayoutSingleton.theme == 'dark',
      'light-theme': LayoutSingleton.theme == 'light',
      'mini-sidebar': !NavigationStateSingleton.dropdown_active.nav_menu,
      'show-sidebar': NavigationStateSingleton.dropdown_active.nav_menu
    }"
    :key="UserSingleton.company_selected?.token">

    <NotifyMessages></NotifyMessages>

    <slot name="content"></slot>
  </div>
</template>
<script setup>
import UserSingleton from '@/Classes/User/UserSingleton';
import LayoutSingleton from '@/Services/App/LayoutSingleton';
import NavigationStateSingleton from '@/Services/App/NavigationStateSingleton';
import NotifyMessages from '../Elements/Notifications/NotifyMessages.vue';
</script>